import EditProductDialog from './EditProductDialog'

export default EditProductDialog
